/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { lazy } from "react";
import { Loadable } from "components/Loadable";

const StyleGuide = Loadable(lazy(() => import("sections/style-guide")));

const styleGuideRoutes = [
    {
        path: "style-guide",
        element: <StyleGuide />,
    },
];

export { styleGuideRoutes };
